

import { useContext, useEffect, useReducer, useState } from 'react';
import { CurrentPContext, OrderContext, OrdStageContext, UserContext } from '../ContextApi/context';
import ShopingCratFloat from './ShopingCratFloat';
import { BrowserRouter as Router, Switch, Route, Link, useParams, useRouteMatch } from "react-router-dom";
import { useHistory } from "react-router-dom";
import OrderTypeSelect from '../OrderSettings/OrderTypeSelect';
import OrderFunctions from '../OrderSettings/OrderFunctions';
import PopUpShopCart from './PopUpShopCart';
import { StackedLineChartRounded } from '@mui/icons-material';
import TheOrderList from '../OrderSettings/TheOrderList';
import Scroll from 'react-scroll';
import PopUpDInnersCheck from './PopUpDInnersCheck';
import PopUpTheComp from './PopUpTheComp';
import PopUpClearComp from './PopUpClearComp';
import LoginPage from '../UsersLogs/LoginPage';

var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const initialState = {
    stage: 0,
    showOrders: "hideOrds",
    theText: "המשך הזמנה",
    totPrice: 0 + " ₪"
}

const ContinueToPayLine = (props) => {
    let { path, url } = useRouteMatch();

    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [user, UserEffectFunction] = useContext(UserContext);
    const [order, setOrder] = useContext(OrderContext);
    const [txtBtn, setTxtBtn] = useState(props.theTxt);
    const [showMe, setShowMe] = useState('hideOrds');
    const [nxUrl, setNxUrl] = useState((props.nxUrl != null) ? props.nxUrl : '/TakeOrDel');
    const history = useHistory();
    const [thePopUp, setThePopUp] = useState("");
    const [siteCart, setSiteCart] = useState({ showme: false });
    const [blokit, setBlokit] = useState(false);

    const [showTopMasterStrip, setShowTopMasterStrip] = useState(true);

    const canOrder =
        (props.doDeliver && !props.master.blockDeliverys.block) ||
        (props.doTakeAway && !props.master.blockPickUps.block);



    useEffect(() => {
        setShowMe((order.Orders.length > 0) ? 'showOrds' : 'hideOrds')
        // setNxUrl((nxUrl == '/TakeOrDel') ? '/MyOrder' : '/#');

    }, [order])

    const loginUsr = () => {
        // history.push("/LoginPage");

        setThePopUp(
            <PopUpClearComp
                popFullComp={"specialPopComp onTopOfAll"}
                cssStyl={"noPadding "}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                insideCss={"noPadding "}
                theInsideComp={
                    <LoginPage
                        theInsideComp={""}
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        shoTopStrp={(tf) => { }}
                        txt1={"התחברות קטנה"}
                        txt2={"יש להתחבר כדי להמשיך"}
                        txt3={""}
                        txt4={""}
                        scrollToTop={(stUp) => { }} />
                } />)


    }

    const nextPage = () => {

        if (user === undefined || (user?.usrmsg && user.usrmsg === "noUser")) {
            loginUsr();
        }
        else if (canOrder) {

            setBlokit(false)
            if (window.location.pathname.startsWith('/restaurants/')) {
                //בודק אם יש רטבים מוצמדים
                let theCOunt = 0;
                order.Orders.forEach((itm, indx) => {
                    if (itm.chkProdSauces) {
                        theCOunt += (parseInt(itm.chkProdValSauces) * itm.mount);
                    }
                    itm.specials?.forEach(specItem => {
                        specItem.spec?.forEach(spItem => {
                            theCOunt += (parseInt(spItem.withSauces) * parseInt(spItem.itmsMount));
                        });
                    });
                })
                if (currentPage.chkForkNife != true &&
                    currentPage.chkChopStiks != true &&
                    currentPage.chkSauces != true) {

                    // props.stickyShow(false)
                    setThePopUp(
                        <PopUpTheComp
                            // closePop={() => { props.stickyShow(true); setThePopUp() }}
                            closePop={() => { setThePopUp() }}
                            cssStyl={"addressSelectPop"}
                            theInsideComp={
                                <OrderTypeSelect
                                    shoTopStrp={(tf) => setShowTopMasterStrip(tf)}
                                    scrollToTop={(stUp) => { }}
                                    showfotter={(fot) => { }}
                                    closePop={() => { setThePopUp() }}
                                    setShowbanners={(bol) => { }} />}
                            Title={[""]}
                        />
                    )
                    // history.push(nxUrl);

                }
                else {
                    popTiming++;
                    setThePopUp(
                        <PopUpDInnersCheck key={popTiming} Title={["סועדים"]}
                            ContentText={["."
                                , ""
                                , `בערך בעוד ${order.OrderTimes} דקות`
                                , "בתאבון!"]}
                            inLabel={""}
                            okClick={() => {
                                setThePopUp(
                                    <PopUpTheComp
                                        // closePop={() => { props.stickyShow(true); setThePopUp() }}
                                        closePop={() => { setThePopUp() }}
                                        cssStyl={"addressSelectPop"}
                                        theInsideComp={
                                            <OrderTypeSelect
                                                shoTopStrp={(tf) => setShowTopMasterStrip(tf)}
                                                scrollToTop={(stUp) => { }}
                                                showfotter={(fot) => { }}
                                                closePop={() => { setThePopUp() }}
                                                setShowbanners={(bol) => { }} />}
                                        Title={[""]}
                                    />
                                )
                            }}
                            cancelClick={() => { setThePopUp(); }}
                            btnClick2={() => { setThePopUp(); }}
                            BtnTxt2={"חזור לתפריט"}
                            errorMsg={""} />
                    )
                }
            }

        }
        else {

            setBlokit(true)
        }
        // history.push(nxUrl);

    }


    const scrolUp = (scInt, animate) => {
        if (animate) {
            scroll.scrollToTop(scInt === 0 ? undefined : scInt);
        }
        else {
            window.scrollTo(0, 0);
        }
    }

    let popTiming = -1;



    return (
        <>
            <div className={`ContinueToPayWrap  ${showMe}`}>
                <div className="ContinueToPayLine" >
                    <div className={"contPayRight"}>
                        <ShopingCratFloat continToPay={() => nextPage()} />
                    </div>
                    {
                        !blokit ?
                            <div className={"contPayLeft"} onClick={() => nextPage()}>
                                <div className={"shopCrt"}>
                                    {(siteCart.theOrdLst) ? siteCart.theOrdLst : ""}
                                </div>
                                <div className={"contToPayText bold big pointing"}>{txtBtn}</div>
                                {(props.withPrice) ? <div className={"priceTxt bold big"}>
                                    ₪ {OrderFunctions.getOrderPrice(order).toFixed(2)}
                                </div> : ""}
                            </div>
                            :

                            <div className={"contPayLeft"} >
                                <div className={"shopCrt"}>
                                    {(siteCart.theOrdLst) ? siteCart.theOrdLst : ""}
                                </div>
                                <div className={"contToPayText bold big pointing"}>לא ניתן לבצע הזמנות כרגע</div>

                            </div>


                    }

                </div>

            </div>

            {thePopUp}
        </>

    )

}
export default ContinueToPayLine;


